/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const reReframeFailureSchema = z.object({
  clipId: z.number(),
  reason: z.string(),
});

export const reReframeVerticalsResponseDataSchema = z.object({
  scanned: z.number(),
  reframed: z.number(),
  uploaded: z.number(),
  failed: z.number(),
  // Total candidates remaining for this mode (lets the UI show progress out of a known total).
  total: z.number().default(0),
  failures: z.array(reReframeFailureSchema).default([]),
  nextCursor: z.string().optional(),
});

export type IReReframeVerticalsResponseData = z.infer<typeof reReframeVerticalsResponseDataSchema>;

export const reReframeVerticalsResponseSchema = createApiResponseSchema(
  reReframeVerticalsResponseDataSchema,
) as z.ZodSchema<IAPI<IReReframeVerticalsResponseData>>;

export type IReReframeVerticalsResponse = IAPI<IReReframeVerticalsResponseData>;
